var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[(_vm.editMode)?_c('v-chip',[_vm._v(" No specific parameters ... it is dummy! ")]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }